import React from 'react';
import { FormCard } from './FormCard';
import authorPhoto from '../assets/amit.jpg';

export const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-text">
          <div className="urgency-strip">
            <div className="urgency-dot"></div>
            <div className="urgency-text">Limited author copies remaining</div>
          </div>
          <h1>
            The AI-First CHRO
            <em>The Missing Playbook — From AI Promise to Boardroom Results</em>
          </h1>
          <p className="hero-desc">
            A narrative-driven playbook for HR leaders navigating AI transformation. Built from{' '}
            <strong>Indian ground realities</strong>. Frameworks forged through{' '}
            <strong>operational experience</strong>, not borrowed from textbooks.
          </p>
          <p className="hero-desc-secondary">
            75 senior HR leaders in India will receive signed author copies before anyone else. No purchase. No strings.
            Just the book — because the content earns its own advocacy.
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-num">6</div>
              <div className="hero-stat-label">Frameworks</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-num">12</div>
              <div className="hero-stat-label">Chapters</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-num">84</div>
              <div className="hero-stat-label">KRAs</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-num">5</div>
              <div className="hero-stat-label">Cheat Sheets</div>
            </div>
          </div>
          <div className="author-strip">
            <img className="author-photo" src={authorPhoto} alt="Amit Srivastava" />
            <div className="author-info">
              <div className="author-name">Amit Srivastava</div>
              <div className="author-bio">Has been on both sides of the AI promise gap — and it is that gap this book exists to close.</div>
              <div className="author-signed">Every copy personally signed</div>
            </div>
          </div>
        </div>

        <div>
          <FormCard />
        </div>
      </div>
    </section>
  );
};
